module.exports = __webpack_public_path__ + "static/img/floor1-lz1.acc6ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-lz1.png
// module id = puyY
// module chunks = 1